import React, { useCallback, useEffect, useState } from "react";
import { platformApi } from "../api";

const EMPTY = { slug: "", name: "", plan: "", adminUsername: "", adminPassword: "" };

export default function Tenants() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(null);
  const [err, setErr] = useState("");
  const load = useCallback(() => platformApi.get("/platform/tenants").then((r) => setRows(r.data?.data || [])).catch((e) => setErr(e.message)), []);
  useEffect(() => { load(); }, [load]);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const create = async (e) => {
    e.preventDefault(); setErr("");
    try { await platformApi.post("/platform/tenants", form); setForm(null); load(); }
    catch (x) { setErr(x?.response?.data?.message || x.message); }
  };
  const toggle = async (t) => {
    const status = t.status === "Active" ? "Suspended" : "Active";
    if (status === "Suspended" && !window.confirm(`Suspend ${t.name}? Its users will be locked out.`)) return;
    await platformApi.put(`/platform/tenants/${t.id}`, { status }); load();
  };
  const setMail = async (t) => {
    const v = window.prompt(`E-mail addresses to notify when Vxaro support requests access to ${t.name} (comma separated, empty to clear):`, t.support_notify_emails || "");
    if (v === null) return;
    try { await platformApi.put(`/platform/tenants/${t.id}`, { support_notify_emails: v }); setErr(""); load(); } catch (x) { setErr(x?.response?.data?.message || x.message); }
  };
  return (
    <div>
      <h1>Tenants</h1>
      {err && <div className="err" style={{ marginBottom: 10 }}>{err}</div>}
      <div className="card">
        <div className="toolbar"><button className="btn primary" onClick={() => setForm(form ? null : { ...EMPTY })}>{form ? "Cancel" : "New tenant"}</button></div>
        {form && (
          <form onSubmit={create} style={{ padding: 12, display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))", gap: 10 }}>
            <div className="form-row"><label>Slug (URL: /t/slug)</label><input value={form.slug} onChange={set("slug")} placeholder="calicut" required /></div>
            <div className="form-row"><label>Name</label><input value={form.name} onChange={set("name")} placeholder="Calicut Urban Bank" required /></div>
            <div className="form-row"><label>Plan</label><input value={form.plan} onChange={set("plan")} /></div>
            <div className="form-row"><label>Admin username</label><input value={form.adminUsername} onChange={set("adminUsername")} required /></div>
            <div className="form-row"><label>Admin password (min 10)</label><input type="password" value={form.adminPassword} onChange={set("adminPassword")} minLength={10} required /></div>
            <div style={{ alignSelf: "end" }}><button className="btn primary">Create tenant</button></div>
          </form>
        )}
        <table>
          <thead><tr><th>Slug</th><th>Name</th><th>Status</th><th>Plan</th><th>Users</th><th>Support e-mails</th><th>Created</th><th /></tr></thead>
          <tbody>
            {rows.map((t) => (
              <tr key={t.id}>
                <td><a href={`/t/${t.slug}/`}>{t.slug}</a></td><td>{t.name}</td>
                <td><span className="pill">{t.status}</span></td><td>{t.plan || "—"}</td><td>{t.users}</td>
                <td>{t.support_notify_emails || "—"}</td>
                <td>{t.created_at ? new Date(t.created_at).toLocaleDateString() : ""}</td>
                <td><button className="btn sm" onClick={() => toggle(t)}>{t.status === "Active" ? "Suspend" : "Activate"}</button> <button className="btn sm" onClick={() => setMail(t)}>Set e-mails</button></td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={8} style={{ textAlign: "center", padding: 20 }}>No tenants</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
